import { render } from "./ViewPartenairePage.vue?vue&type=template&id=c74514a6&ts=true"
import script from "./ViewPartenairePage.vue?vue&type=script&lang=ts"
export * from "./ViewPartenairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__